import React, { useEffect, useContext, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesRegister() {
	const context = useContext(AppSettings);
	const [redirect, setRedirect] = useState(false);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		context.setAppContentFullHeight(true);
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
			context.setAppContentFullHeight(false);
		};
		
		// eslint-disable-next-line
	}, []);
	
	function handleSubmit(event) {
		event.preventDefault();
		
		setRedirect(true);
  }
  
	if (redirect) {
		return <Navigate to='/' />;
	}
	return (
		<div className="register">
			<div className="register-content">
				<form onSubmit={handleSubmit}>
					<h1 className="text-center">Sign Up</h1>
					<p className="text-muted text-center">One Admin ID is all you need to access all the Admin services.</p>
					<div className="mb-3">
						<label className="form-label">Name <span className="text-danger">*</span></label>
						<input type="text" className="form-control form-control-lg fs-15px" placeholder="e.g John Smith" defaultValue="" />
					</div>
					<div className="mb-3">
						<label className="form-label">Email Address <span className="text-danger">*</span></label>
						<input type="text" className="form-control form-control-lg fs-15px" placeholder="username@address.com" defaultValue="" />
					</div>
					<div className="mb-3">
						<label className="form-label">Password <span className="text-danger">*</span></label>
						<input type="password" className="form-control form-control-lg fs-15px" defaultValue="" />
					</div>
					<div className="mb-3">
						<label className="form-label">Confirm Password <span className="text-danger">*</span></label>
						<input type="password" className="form-control form-control-lg fs-15px" defaultValue="" />
					</div>
					<div className="mb-3">
						<label className="form-label">Country <span className="text-danger">*</span></label>
						<select className="form-control form-control-lg fs-15px">
							<option>United States</option>
						</select>
					</div>
					<div className="mb-3">
						<label className="form-label">Gender <span className="text-danger">*</span></label>
						<select className="form-control form-control-lg fs-15px">
							<option>Female</option>
						</select>
					</div>
					<div className="mb-3">
						<label className="form-label">Date of Birth <span className="text-danger">*</span></label>
						<div className="row">
							<div className="col-6">
								<select className="form-select form-select-lg fs-15px">
									<option>Month</option>
								</select>
							</div>
							<div className="col-3">
								<select className="form-select form-select-lg fs-15px">
									<option>Day</option>
								</select>
							</div>
							<div className="col-3">
								<select className="form-select form-select-lg fs-15px">
									<option>Year</option>
								</select>
							</div>
						</div>
					</div>
					<div className="mb-3">
						<div className="form-check">
							<input className="form-check-input" type="checkbox" defaultValue="" id="customCheck1" />
							<label className="form-check-label fw-500" htmlFor="customCheck1">I have read and agree to the <a href="#/">Terms of Use</a> and <a href="#/">Privacy Policy</a>.</label>
						</div>
					</div>
					<div className="mb-3">
						<button type="submit" className="btn btn-theme btn-lg fs-15px fw-500 d-block w-100">Sign Up</button>
					</div>
					<div className="text-muted text-center">
						Already have an Admin ID? <Link to="/pages/login">Sign In</Link>
					</div>
				</form>
			</div>
		</div>
	)
}

export default PagesRegister;